import styled, { css } from 'styled-components';
import { colors } from '~/styles/colors';
import { mobileQuery } from './ds';

const PRIMARY = colors.brand.primary.base;
const STROKE = colors.stroke['soft-200'];

/** Topo da tela do Modo Eco simplificado, com o selo de conexão do DAM. */
export const ScreenHeader = styled.div`
  display: flex;
  align-items: stretch;
  gap: 28px;
  margin-bottom: 28px;
  border-bottom: 1px solid ${STROKE};
  font-family: Inter, sans-serif;

  ${mobileQuery} {
    flex-wrap: wrap;
    gap: 0;
    margin-bottom: 16px;
  }
`;

export const StatusPill = styled.span<{ $online: boolean }>`
  display: inline-flex;
  align-items: center;
  align-self: center;
  gap: 8px;
  margin: 10px 0 10px auto;
  padding: 6px 14px 6px 12px;
  border-radius: 999px;
  background: ${({ $online }) => ($online ? PRIMARY : colors.bg['soft-400'])};
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  white-space: nowrap;
  color: ${colors.text['white-0']};

  /* No celular o selo fica à esquerda, como no design mobile. */
  ${mobileQuery} {
    order: -1;
    margin: 0 0 8px;
    align-self: flex-start;
  }

  &::before {
    content: "";
    display: inline-block;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: ${({ $online }) => ($online ? colors.celsius['spring-green'] : colors.stroke['sub-300'])};
    ${({ $online }) => $online && css`box-shadow: 0 0 0 3px ${colors.celsius['spring-green-glow']};`}
  }
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 40px 0;
`;

export const ReadOnlyNotice = styled.div`
  margin-bottom: 20px;
  padding: 12px 16px;
  border: 1px solid ${colors.celsius['warning-light']};
  border-radius: 8px;
  background: ${colors.celsius['warning-lighter']};
  font-family: Inter, sans-serif;
  font-size: 13px;
  color: ${colors.celsius['warning-dark']};
`;

export const ReadOnlyArea = styled.fieldset`
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
  pointer-events: none;
  opacity: 0.7;
`;
